import LoginStyles from '../Login/LoginStyles';

// Reuse the Login page look-and-feel (card, outlined fields, gradient button) and
// add a few forgot-password-specific pieces so the two screens feel consistent.
const ForgotPasswordStyles = theme => ({
  ...LoginStyles(theme),
  forgotWrapper: {
    width: '100%',
    minHeight: 'calc(100vh - 140px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // Clear the fixed top nav bar (~45px, plus the iOS safe-area var) so the card
    // isn't hidden underneath it.
    padding: 'calc(var(--top-padding, 0px) + 60px) 16px 32px',
    boxSizing: 'border-box',
    background: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      padding: 'calc(var(--top-padding, 0px) + 60px) 16px 24px'
    }
  },
  forgotIcon: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
    color: '#ffffff',
    background: 'var(--my-gradient)',
    boxShadow: '0 6px 16px 0 rgba(57, 102, 248, 0.35)'
  },
  forgotHint: {
    color: '#64748b',
    fontSize: '14px',
    lineHeight: 1.5,
    textAlign: 'center',
    maxWidth: 360,
    margin: '0 auto 8px'
  },
  forgotButtonWrap: {
    marginTop: theme.spacing(1)
  },
  // Reset-password page centres the same card, but it already sits inside
  // AppContentContainer (which adds the top-nav padding), so no extra nav offset here.
  resetWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px 16px 32px',
    boxSizing: 'border-box',
    background: '#ffffff'
  },
  backToLoginBtn: {
    marginTop: theme.spacing(1.5),
    textTransform: 'none',
    fontWeight: 600
  }
});

export default ForgotPasswordStyles;
